export default __webpack_public_path__ + "static/media/Hand_left.6b8e0a1f.svg";